<script setup lang="ts"></script>

<template>
  <div class="w-full p-6 md:p-12 relative backdrop-blur-xl border bg-gray-900/40 border-gray-800/30 rounded-3xl shadow-xl">
    <slot />
  </div>
</template>

<style scoped lang="scss">
</style>
